var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LazyImgWrapper',{attrs:{"cover":_vm.fit || 'contain'}},[_c('img',{class:[{ 'show-image' : _vm.loaded }, 'lazy-img'],attrs:{"src":_vm.srcImage},on:{"load":_vm.imgLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }